import API from "../../../store/api";
import { setNotifications } from '../../../store/actions/notificationActions';
import { clearMessage, setMessage } from '../../../store/actions/dialogActions';
import { clearEsriSuggestions, setEsriSuggestions } from '../../../store/actions/esriActions';
import { authLogout } from '../../../store/actions/authActions';

export const esriSuggest = (address, bearerAuth) => {
  return async dispatch => {


    API.post(`/api/portal/esri/suggest`)
      .set('Authorization', `Bearer ${bearerAuth}`)
      .send({ address: address })
      .ok(res => res.status === 201 || res.status === 401)
      .then((response) => {
        if (response.status === 201) {
          dispatch(setEsriSuggestions(JSON.parse(response.body).suggestions))
        } else if (response.status === 401) {
          dispatch(clearEsriSuggestions);
          dispatch(authLogout);
        }
      }).catch((error) => {
        let message = 'An error has occurred';
        if (error.message) {
          message = error.message;
        }
        if (error.response && error.response.body) {
          if (error.response.body.messages) {
            message = error.response.body.messages.toString();
            if (message.includes(',')) { //Password error, make it more presentable
              let messageArray = message.split(',');
              message = <>{messageArray.map((val) => <div>{val}</div>)}</>
            }
          } 
        }
        dispatch(setMessage({
          title: 'Failed to pull address suggestions',
          message: message,
          type: 'ERR',
        }))
      })
  }
}